export default function ResultsTable(props) {
	
	console.log(props.resultsData)

	let objPortfolioData = {
		benchmarkData: '—',
		effectiveDuration: '—',
		prospectusNetExpenseRatio: '—',
		threeYearAnnualized: '—',
		threeYearRiskAnnualized: '—',
		twelveMonthTrailingYield: '—',
		taxes: '—',
	}


	if (props.resultsData && props.resultsData.portfolioResponse && props.resultsData.portfolioResponse.portfolio) {
		
		let myresultsData = props.resultsData.portfolioResponse
		
		console.log(myresultsData.portfolio)
		console.log(myresultsData.portfolio.characteristics[0].total)

		let bmData = '-'

	
	
		// Make sure the data coming in fits what we need, or else we just stick to the defaults.
		if (myresultsData.portfolio && 
			myresultsData.portfolio.characteristics[0].total) {
	
			let prospectusNetExpenseRatio = myresultsData.portfolio.characteristics[3].total;
			let effectiveDuration =  myresultsData.portfolio.characteristics[0].total
			let twelveMonthTrailingYield =  myresultsData.portfolio.characteristics[2].total
			let threeYearAnnualized = myresultsData.portfolio.performance.expostMetrics.metrics[20].value;
			let threeYearRiskAnnualized =  myresultsData.portfolio.performance.expostMetrics.metrics[25].value;
			let benchmarkData =  myresultsData.portfolio.performance.expostMetrics.metrics[17].value;
		
	
			objPortfolioData = {
				...objPortfolioData,
				effectiveDuration: (effectiveDuration?(effectiveDuration).toFixed(2):'—') + '',
				twelveMonthTrailingYield: (twelveMonthTrailingYield?(twelveMonthTrailingYield).toFixed(2):'—') + '%',
				prospectusNetExpenseRatio: (prospectusNetExpenseRatio?(prospectusNetExpenseRatio).toFixed(2):'—') + '%',
				threeYearRiskAnnualized: (threeYearRiskAnnualized?(threeYearRiskAnnualized*100).toFixed(2):'—') + '%',
				benchmarkData: (benchmarkData?(benchmarkData).toFixed(2):'—') + ''
			}
	
		
		}


		

	} else {
		console.log('Portfolio data is undefined');
	}




	
	
	return (
		<div className="results-table" >
			<table width='98%'>
				<tbody>
					<tr>
						<th>
							<span>Blended yield*</span>
					
						</th>
						<td>
							{objPortfolioData.twelveMonthTrailingYield}
							{/* 3.57% */}
						</td>
					
					</tr>
					<tr>
						<th>
							<span>Blended net expense ratio</span>
					
						</th>
						<td>
							{objPortfolioData.prospectusNetExpenseRatio}
							{ /* 0.46% */}
						</td>
					
					</tr>
					<tr>
						<th>
							<span>Avg. effective duration</span>
					
						</th>
						<td>
							{objPortfolioData.effectiveDuration} years
							{ /* 4.16% */ }
						</td>
					
					</tr>
					<tr>
						<th>
							<span>Standard deviation (3y)</span>
					
						</th>
						<td>
							{objPortfolioData.threeYearRiskAnnualized}
							{ /* 2.07%  */ }
						</td>
					</tr>
					<tr>
						<th>
							<span>Correlation to S&P 500 (3y)*</span>
						</th>
						<td>
							{objPortfolioData.benchmarkData}
							{ /* 0.48 */ }
						</td>
					
					</tr>
									
				</tbody>
			</table>
		</div>
	)
}